<template>
  <div class="searchBox">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" label-width="58px">
      <el-row>
        <el-form-item v-if="areaLevel == 1" label="省份：" prop="province">
          <el-select v-model="queryParams.province" size="small" style="width: 1.6rem;" @change="provinceChange">
            <el-option v-for="dict in provinceOption" :key="dict.id" :label="dict.name" :value="dict.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="areaLevel == 1 || areaLevel == 2" label="城市：" prop="city">
          <el-select v-model="queryParams.city" size="small" style="width: 1.6rem;" @change="cityChange">
            <el-option v-for="dict in marketOption" :key="dict.id" :label="dict.name" :value="dict.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="areaLevel == 1 || areaLevel == 2" label="县（市区）：" prop="area" label-width="100px">
          <el-select v-model="queryParams.area" size="small" style="width: 1.6rem;" @change="areaChange">
            <el-option v-for="dict in areaOption" :key="dict.id" :label="dict.name" :value="dict.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="(areaLevel == 1 || areaLevel == 2 || areaLevel == 3 || areaLevel == 4) && htmlName != '活动'" label="学校：" prop="sid" label-width="80px">
          <el-select v-model="queryParams.sid" size="small" style="width: 2rem;" filterable>
            <el-option v-for="dict in schoolList" :key="dict.sid" :label="dict.sname" :value="dict.sid" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="htmlName == '群组'" label="群组名称：" prop="groupName" label-width="84px">
          <el-input v-model="queryParams.groupName" placeholder="输入群组名称" clearable style="width: 2.2rem;" />
        </el-form-item>
        <el-form-item v-if="htmlName == '群组'" label="学科：" prop="subjectId">
          <el-select v-model="queryParams.subjectId" size="small" clearable style="width: 1.6rem;">
            <el-option v-for="dict in subjectOption" :key="dict.subjectId" :label="dict.subjectName"
              :value="dict.subjectId" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="htmlName == '计划'" label="时间：" prop="createTime">
          <el-date-picker v-model="queryParams.createTime" value-format="yyyy" type="year" style="width: 2rem;" />
        </el-form-item>
        <el-form-item v-if="htmlName == '计划'" label="计划名称：" prop="name" label-width="84px">
          <el-input v-model="queryParams.name" placeholder="输入计划名称" clearable style="width: 2.2rem;" />
        </el-form-item>
        <el-form-item v-if="htmlName == '任务'" label="时间：" prop="createTime">
          <el-date-picker
            v-model="queryParams.createTime"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd hh:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 3.5rem;">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="htmlName == '任务'" label="任务名称：" prop="name" label-width="84px">
          <el-input v-model="queryParams.name" placeholder="输入任务名称" clearable style="width: 2.2rem;" />
        </el-form-item>
        <el-form-item v-if="htmlName == '活动'" label="状态：" prop="readType">
          <el-select v-model="queryParams.readType" size="small" style="width: 1.2rem;">
            <el-option v-for="dict in readtypeOption" :key="dict.id" :label="dict.name" :value="dict.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="htmlName == '活动'" label="时间：" prop="createTime">
          <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange"
            start-placeholder="开始日期" end-placeholder="结束日期" style="width: 2.6rem;" />
        </el-form-item>
        <el-form-item style="margin-right: .2rem;">
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import { gettypeList, getclazzList, getsubjectList } from "@/api/video";
  import { getProvinceList, getCityList, getmanageSchoolSelect } from "@/api/school";
  import { getTypeTList, getClassList } from "@/api/teacher";
  import { getTeacherInfo } from '@/api/login'
  export default {
    props: {
      htmlName: {
        type: String,
        default: ''
      },
      queryParams: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      return {
        typeOption: [],
        subjectOption: [],
        yearOption: [],
        levelOption: [],
        provinceOption: [],
        marketOption: [{ name: '全部', id: null }],
        schoolList: [],
        areaOption: [{ name: '全部', id: null }],
        readtypeOption: [
          { name: '全部', id: 0 },
          { name: '未开始', id: 1 },
          { name: '进行中', id: 2 },
          { name: '已结束', id: 3 },
        ],
        areaLevel: '',     // 管理中心的搜索权限
      };
    },
    created() {
      this.typeChange();
      getTeacherInfo(sessionStorage.getItem("userId")).then(res => {
        if (res.code == 200 && res.data.tApiAuthorityManage && res.data.tApiAuthorityManage.length != 0) {
          var levelArr = res.data.tApiAuthorityManage.map((res2) => res2.areaLevel);
          this.areaLevel = Math.min.apply(null, levelArr);
          sessionStorage.setItem("areaLevel", this.areaLevel);
          var manageInfo = res.data.tApiAuthorityManage;
          var levelData = [];
          for(var i = 0; i < manageInfo.length; i++) {
            if(manageInfo[i].areaLevel == this.areaLevel) {
              levelData.push(manageInfo[i]);
            }
          }
          if(this.areaLevel == 1) {
            if(levelData.length == 1) {
              this.provinceOption = [{ name: '全部', id: null },{ name: levelData[0].provinceName, id: levelData[0].province }]
              getCityList({ pid: levelData[0].province }).then(response => {
                if (response.code == 200) {
                  response.data.unshift({ name: '全部', id: null })
                  this.marketOption = response.data;
                }
              });
            } else {
              this.provinceOption = [{ name: '全部', id: null }];
              for(var i = 0; i < levelData.length; i++) {
                this.provinceOption.push({ name: levelData[i].provinceName, id: levelData[i].province })
              }
            }
            this.schoolList = [{ sname: '全部', sid: null }]
          } else if(this.areaLevel == 2) {
            if(levelData.length == 1) {
              this.marketOption = [{ name: '全部', id: null },{ name: levelData[0].cityName, id: levelData[0].city }]
              getCityList({ pid: levelData[0].city }).then(response => {
                if (response.code == 200) {
                  response.data.unshift({ name: '全部', id: null })
                  this.areaOption = response.data;
                }
              });
            } else {
              this.marketOption = [{ name: '全部', id: null }];
              for(var i = 0; i < levelData.length; i++) {
                this.marketOption.push({ name: levelData[i].cityName, id: levelData[i].city })
              }
            }
            this.schoolList = [{ sname: '全部', sid: null }]
          } else if(this.areaLevel == 3) {
            if(levelData.length == 1) {
              this.areaOption = [{ name: '全部', id: null },{ name: levelData[0].areaName, id: levelData[0].area }]
            } else {
              this.areaOption = [{ name: '全部', id: null }];
              for(var i = 0; i < levelData.length; i++) {
                this.areaOption.push({ name: levelData[i].areaName, id: levelData[i].area })
              }
            }
            this.schoolList = [{ sname: '全部', sid: null }]
          } else if(this.areaLevel == 4) {
            if(levelData.length == 1) {
              this.schoolList = [{ sname: '全部', sid: null }]
            } else {
              this.schoolList = [{ sname: '全部', sid: null }]
            }
          }
        }
      })
    },
    methods: {
      getSchoolList() {
        var json = {
          province: this.queryParams.province,
          city: this.queryParams.city,
          area: this.queryParams.area,
        }
        var province,city, area;
        if(this.queryParams.province) {
          province = this.queryParams.province;
        } else {
          province = '';
        }
        if(this.queryParams.city) {
          city = this.queryParams.city;
        } else {
          city = '';
        }
        if(this.queryParams.area) {
          area = this.queryParams.area;
        } else {
          area = '';
        }
        getmanageSchoolSelect(province,city,area,'').then(res =>{
          if(res.code == 200){
            res.data.unshift({ sname: '全部', sid: null })
            this.schoolList = res.data
          }
        })
      },
      typeChange(e) {
        getsubjectList({ typeId: e }).then(response => {
          response.data.unshift({ subjectName: '全部', subjectId: null })
          this.subjectOption = response.data;
        });
        getclazzList({ typeId: e }).then(response => {
          response.data.unshift({ clazzName: '全部', clazzId: null })
          this.yearOption = response.data;
        });
      },
      // 下拉省的选择
      provinceChange(e) {
        this.queryParams.city = null;
        this.queryParams.area = null;
        if (e) {
          getCityList({ pid: e }).then(response => {
            response.data.unshift({ name: '全部', id: null })
            this.marketOption = response.data;
          });
        } else {
          this.marketOption = [{ name: '全部', id: null }];
          this.areaOption = [{ name: '全部', id: null }];
        }
        if(this.queryParams.province){
          this.getSchoolList();
        }else{
          this.schoolList = [{ sname: '全部', sid: null }]
        }
      },
      // 下拉市的选择
      cityChange(e) {
        this.queryParams.area = null;
        this.queryParams.sid =null
        if (e) {
          getCityList({ pid: e }).then(response => {
            response.data.unshift({ name: '全部', id: null })
            this.areaOption = response.data;
          });
        } else {
          this.areaOption = [{ name: '全部', id: null }];
        }
        if(this.queryParams.city){
          this.getSchoolList();
        }else{
          this.schoolList = [{ sname: '全部', sid: null }]
        }
      },
      areaChange(e) {
        this.getSchoolList();
      },
      handleSearch() {
        this.queryParams.pageNum = 1;
        this.$emit('handleQuery', this.queryParams);
      },
    }
  };
</script>

<style>
  .searchBox {
    padding-top: .16rem;
  }

  .searchBox>>>.el-form-item__label {
    text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/ManageSearch.vue